export default __webpack_public_path__ + "static/media/laptop-basic.fce40ded.png";